var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconClipboard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 61,
  height: 80,
  viewBox: "0 0 61 80",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M50.7812 6.25H38.996C37.7057 2.6123 34.2303 0 30.1562 0C26.0822 0 22.6068 2.6123 21.3165 6.25H9.375C4.20532 6.25 0 10.4553 0 15.625V70.625C0 75.7947 4.20532 80 9.375 80H50.791C55.9552 79.9945 60.1562 75.7892 60.1562 70.625V15.625C60.1562 10.4553 55.9509 6.25 50.7812 6.25ZM27.0312 12.5V9.375C27.0312 7.65198 28.4332 6.25 30.1562 6.25C31.8793 6.25 33.2812 7.65198 33.2812 9.375V12.5H39.5312V18.5938H20.7812V12.5H27.0312ZM53.9062 70.625C53.9062 72.3462 52.5055 73.7482 50.788 73.75H9.375C7.65198 73.75 6.25 72.348 6.25 70.625V15.625C6.25 13.902 7.65198 12.5 9.375 12.5H14.5312V24.8438H45.7812V12.5H50.7812C52.5043 12.5 53.9062 13.902 53.9062 15.625V70.625ZM42.0636 35.9436L46.6858 40.1501L26.6718 62.1423L13.4521 49.3555L17.7979 44.8633L26.3861 53.1702L42.0636 35.9436Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClipboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_clipboard.20406846.svg";
export { ForwardRef as ReactComponent };